import { defineMessages } from 'react-intl'

const scope = 'app.containers.Preview'

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the Preview!',
  },
})
